/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationPipelineConfigUpdate } from '../../axios/organisationPipelineConfigUpdate'
import type {
	OrganisationPipelineConfigUpdateError,
	OrganisationPipelineConfigUpdatePathParams,
	OrganisationPipelineConfigUpdateRequest,
	OrganisationPipelineConfigUpdateResponse,
} from '../../types/OrganisationPipelineConfigUpdate'

export const organisationPipelineConfigUpdateMutationKey = () =>
	[{ url: '/organisations/:organisation/pipeline-config' }] as const

export type OrganisationPipelineConfigUpdateMutationKey = ReturnType<typeof organisationPipelineConfigUpdateMutationKey>

export type OrganisationPipelineConfigUpdateVariables = {
	organisation: OrganisationPipelineConfigUpdatePathParams['organisation']
	data: OrganisationPipelineConfigUpdateRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::update */
export function useOrganisationPipelineConfigUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationPipelineConfigUpdateResponse,
		AxiosError<OrganisationPipelineConfigUpdateError>,
		OrganisationPipelineConfigUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationPipelineConfigUpdateMutationKey(),
		mutationFn: ({ organisation, data }: OrganisationPipelineConfigUpdateVariables) =>
			organisationPipelineConfigUpdate(organisation, data, config).then(res => res.data),
		...options,
	})
}
